import { formatCurrency, formatNumber, formatSize } from 'lib/helpers/strings';

export { formatCurrency, formatSize, formatNumber };

interface IProps {
  value: number;
  percent?: boolean;
  locale?: string;
  precision?: number;
  options?: any;
  className?: string;
}

const NumberComponent = ({ value, locale = 'en-US', percent = false, precision = 2, options = {}, ...props }: IProps) => {
  const numberStr = formatNumber({ value, locale, percent, precision, options });

  return <span {...props}>{numberStr}</span>;
};

export default NumberComponent;
